import './scripts/common';
import './form';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as actionChanger from '@elements/action-changer';
actionChanger.init();

import * as additionalServicesFilter from './scripts/additional-services-filter';
additionalServicesFilter.init();

import * as additionalServicesSelection from './scripts/additional-services-selection';
additionalServicesSelection.init();

import * as serviceEnquiry from './scripts/service-enquiry';
serviceEnquiry.init();

import * as datepickerReset from './scripts/datepicker-reset';
datepickerReset.init();

import * as filterMobile from './scripts/filter-mobile';
filterMobile.init();